export class EntraRestoreJobReport {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "available",
            "baseName": "available",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "restoredByType",
            "baseName": "restoredByType",
            "type": "{ [key: string]: number; }",
            "format": ""
        },
        {
            "name": "requiredActions",
            "baseName": "requiredActions",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EntraRestoreJobReport.attributeTypeMap;
    }
    constructor() {
    }
}
